/**
 * Shared utility for determining Firebase database paths for feed posts.
 * Used by both feedSlice and publicFeedSlice to avoid code duplication.
 */

/**
 * Returns the Firebase database path for a given feed item based on its type.
 * @param feedItem The feed item metadata (must have postType/type and owner)
 * @param key The feed item key
 * @returns The database path string, or null for unknown types
 */
export function getDbPathForPost(feedItem: { postType?: string; type?: string; owner?: string; itemRef?: string }, key: string): string | null {
  // If there's a direct itemRef, use it
  if (feedItem.itemRef) {
    return feedItem.itemRef;
  }

  const type = feedItem.postType || feedItem.type;
  const owner = feedItem.owner || '';

  switch (type) {
    case 'training':
      return `trainings/${key}`;
    case 'competition':
      return `competitions/${key}`;
    case 'beltPromotion':
    case 'promotion':
      return `beltPromotions/${owner}/${key}`;
    case 'exercise':
      return `exercises/${owner}/${key}`;
    case 'story':
      return `stories/${owner}/${key}`;
    case 'workoutSession':
      return `workoutSessions/${owner}/${key}`;
    case 'topic':
      return `topics/${owner}/${key}`;
    case 'post':
      return `posts/${key}`;
    default:
      return null;
  }
}

/**
 * Returns true if the post type requires injecting owner from feedItem
 * (i.e., the actual post data doesn't contain an 'owner' field)
 */
export function postTypeNeedsOwner(type: string): boolean {
  return ['beltPromotion', 'promotion', 'exercise', 'story', 'workoutSession', 'topic'].includes(type);
}
